// extracted by mini-css-extract-plugin
module.exports = {"placesInput":"Places_placesInput__2pg9h","suggestionContainer":"Places_suggestionContainer__1s9ax","suggestion":"Places_suggestion__kqhUu"};